import {parsePhoneNumber} from 'awesome-phonenumber'

export default class PhoneNumber {
  constructor (original, isoCountryCode) {
    this.original = original
    if (!original || typeof original !== 'string') {
      throw new Error('You must supply a phone number')
    }
    this.parsed = parsePhoneNumber(original, {regionCode: isoCountryCode})
  }

  static fromTropics ({
    internationalCode,
    areaCode,
    number,
    isoCountryCode,
  }) {
    internationalCode = internationalCode || ''
    internationalCode = internationalCode.replace('+', '')

    const fullNumber = areaCode
      ? `+${Number(internationalCode.match(/(\d*)/)[1])}${areaCode}${number}`
      : `+${Number(internationalCode.match(/(\d*)/)[1])}${number}`

    return new PhoneNumber(fullNumber, isoCountryCode)
  }

  internationalCodeIsValid () {
    return Boolean(this.parsed.regionCode)
  }

  isValid () {
    return this.parsed.valid
  }

  isMobile () {
    return Boolean((this.parsed.type || '').match('mobile'))
  }

  toString () {
    // E.164 is an international standard that defines a numbering plan
    return this.parsed.number.e164 || this.original
  }

  toTropics ({
    internationalCodePrefix = '+',
    areaCodeFallback = '',
    enforceAreaCodeExtraction = false,
  } = {}) {
    if (!this.parsed.regionCode) {
      return undefined
    }

    const shouldExtractAreaCode = enforceAreaCodeExtraction || !this.isMobile()

    const regex = /tel:(?<country>\+\d+)-(?<areaCode>\d+)-(?<number>[\d-]+)$/

    const {significant, rfc3966} = this.parsed.number

    const parsed = regex.exec(rfc3966)

    const areaCode = parsed?.groups.areaCode
    const number = parsed?.groups.number.replaceAll('-', '')

    return {
      internationalCode: `${internationalCodePrefix}${this.parsed.countryCode}`,
      areaCode: shouldExtractAreaCode ? areaCode : areaCodeFallback,
      number: shouldExtractAreaCode ? number : significant,
    }
  }
}
